import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardFilled,
  SettingOutlined,
  LogoutOutlined,
  FileTextOutlined,
  BellTwoTone,
  FileSearchOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  BookOutlined,
  FileDoneOutlined, 
  EditOutlined,
  AreaChartOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, theme, Space, Dropdown, message } from "antd";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../components/messages/ResponseMessages";
import { capitalizeAndRemoveUnderscores } from '../../utils/utils'
import { onChangeCollapsed } from '../../app/slice/globalData.js'
import { useDispatch, useSelector } from "react-redux";
import useAuthSync from "../../utils/hook/useAuthSync.js";
import Notification from "./Notification.jsx";
import { fetchAllNotifications } from "../../app/slice/chatSlice.js";
import logo from '../../assets/images/coreventum_logo.png';
import axiosInstance from "../../utils/axiosInstance.js";
import { setAccessGranted } from "../../app/slice/authSlice.js";

const { SubMenu } = Menu;

const { Header, Sider, Content, Footer } = Layout;
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const AntSidebar = () => {
  const [open, setOpen] = useState(false);
  const [accessCode, setAccessCode] = useState("");
  const select = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const userRole = select.userInfo.role;
  const userName = select.userInfo.name;
  const userEmail = select.userInfo.user_email;
  const { logout: logOuted } = useAuthSync();
  const notifications = useSelector((state) => state.chat.allNotification);
  const user_id = useSelector((store) => store.auth.userInfo.user_id);
  const company_id = useSelector((store) => store.auth.userInfo.company_id);
  const notificationRef = useRef(null);
  const bellRef = useRef(null);
  const navigate = useNavigate();
  const accessGranted = select?.userInfo?.is_access_granted;

  const handleSubmitAccessCode = async () => {
    try {
      const res = await axiosInstance.post("/company/verify-access-code/", {
        company_id: company_id,
        entered_code: accessCode,
      });
      dispatch(setAccessGranted(true));
      const msg = res?.data?.message || "Access granted.";
      message.success(msg);
    } catch (error) {
      console.error("Error during sending code:", error);
      const errorMsg =
        error?.response?.data?.error || "Something went wrong. Try again.";
      message.error(errorMsg);
    }
  };

  const handleLogout = () => {
    logOuted()
    navigate("/auth/login");
    logout("Logged-out Successfully.");
  };

  useEffect(() => {
    dispatch(fetchAllNotifications({ user_id }));
  }, [])

  const superAdminMenu = [
    getItem(
      <Link to="dashboard">Dashboard</Link>,
      "/admin/dashboard",
      <DashboardFilled />
    ),
    getItem(
      <Link to="contracts">Contracts</Link>,
      "/admin/contracts",

      <BookOutlined />
    ),
    getItem(
      <Link to="analytics">Analytics</Link>,
      "/admin/analytics",
      <AreaChartOutlined />
    ),
    getItem(
      <Link to="template">Templates</Link>,
      "/admin/template",
      <FileTextOutlined />
    ),
    getItem(
      <Link to="clause">Clause</Link>,
      "/admin/clause",
      <FileDoneOutlined />
    ),
    getItem(
      <Link to="settings">Settings</Link>,
      "/admin/settings",
      <SettingOutlined />
    ),
  ];

  const adminMenu = [
    getItem(
      <Link to="dashboard">Dashboard</Link>,
      "/admin/dashboard",
      <DashboardFilled />
    ),
    getItem(
      <Link to="contracts">Contracts</Link>,
      "/admin/contracts",

      <BookOutlined />
    ),
    getItem(
      <Link to="analytics">Analytics</Link>,
      "/admin/analytics",
      <AreaChartOutlined />
    ),
    getItem(
      <Link to="esign">Esign</Link>,
      "/admin/esign",
      <EditOutlined />

    ),
    getItem(
      <Link to="settings">Settings</Link>,
      "/admin/settings",
      <SettingOutlined />
    ),

  ];

  const othersMenu = [
    getItem(
      <Link to="dashboard">Dashboard</Link>,
      "/admin/dashboard",
      <DashboardFilled />
    ),
    getItem(
      <Link to="contracts">Contracts</Link>,
      "/admin/contracts",
      <BookOutlined />
    ),
    getItem(
      <Link to="analytics">Analytics</Link>,
      "/admin/analytics",
      <AreaChartOutlined />
    ),
    getItem(
      <Link to="esign">Esign</Link>,
      "/admin/esign",
      <EditOutlined />

    ),
    getItem(
      <Link to="settings">Settings</Link>,
      "/admin/settings",
      <SettingOutlined />
    ),

  ];

  const legalMenu = [
    getItem(
      <Link to="dashboard">Dashboard</Link>,
      "/admin/dashboard",
      <DashboardFilled />
    ),
    getItem(
      <Link to="contracts">Contracts</Link>,
      "/admin/contracts",
      <BookOutlined />
    ),
    getItem(
      <Link to="analytics">Analytics</Link>,
      "/admin/analytics",
      <AreaChartOutlined />
    ),
    getItem(
      <Link to="esign">Esign</Link>,
      "/admin/esign",
      <EditOutlined />

    ),
    getItem(
      <Link to="template">Templates</Link>,
      "/admin/template",
      <FileTextOutlined />
    ),
    getItem(
      <Link to="clause">Clause</Link>,
      "/admin/clause",
      <FileDoneOutlined />
    ),
    getItem(
      <Link to="settings">Settings</Link>,
      "/admin/settings",
      <SettingOutlined />
    ),

  ];


  const items = useMemo(() => {
    const baseItems = [
      {
        label: (
          <div className="cursor-auto">
            <span className="font-bold">Signed in as</span> <br />
            <h1>{userEmail && userEmail}</h1>
          </div>
        ),
        key: "0",
      },
      {
        type: "divider",
      },
      {
        label: (
          <div className="cursor-auto">
            <h3 className="flex items-center cursor-auto">
              <UserOutlined className="mr-2" /> Role : {userRole ? capitalizeAndRemoveUnderscores(userRole) : ''}
            </h3>
          </div>
        ),
        key: "1",
      },
      {
        type: "divider",
      },
    ];

    // Conditionally add support link only if not superadmin
    if (userRole !== "superadmin" && userRole !== "support") {
      baseItems.push(
        {
          label: (
            <Link className="flex items-center" to="/admin/support">
              <h3 className="flex items-center">
                <CustomerServiceOutlined className="mr-2" /> Support
              </h3>
            </Link>
          ),
          key: "3",
        },
        {
          type: "divider",
        }
      );
    }

    // Always add signout
    baseItems.push({
      label: (
        <Link onClick={handleLogout} className="flex items-center" to="/auth/login">
          <LogoutOutlined className="mr-2" /> <span>Signout</span>
        </Link>
      ),
      key: "4",
    });

    return baseItems;
  }, [userEmail, userRole, handleLogout]);


  const isCollapsed = useSelector((state) => state.globalDataSlice.isCollapsed);
  const location = useLocation();
  const currentPath = location.pathname;
  const [selectedKey, setSelectedKey] = useState("");

  useEffect(() => {
    let menuList = [];

    const role = userRole?.toLowerCase();
    if (role === "admin") {
      menuList = adminMenu;
    } else if (role === "superadmin") {
      menuList = superAdminMenu;
    } else if (role === "agreement controller head" || role === "agreement controller team") {
      menuList = legalMenu;
    } else {
      menuList = othersMenu;
    }

    const matchedItem = menuList.find(item =>
      location.pathname.startsWith(item.key)
    );

    if (matchedItem) {
      setSelectedKey(matchedItem.key);
    } else {
      setSelectedKey(""); // fallback
    }
  }, [location.pathname, userRole]);


  // const isDashboardPage =
  //   location.pathname.startsWith("/admin/dashboard") ||
  //   location.pathname.startsWith("/admin/analytics");
  const isDashboardPage = /^\/admin\/(dashboard)(?:\/|$)/.test(
    location.pathname
  );
  const isAnalyticsPage = /^\/admin\/(analytics)(?:\/|$)/.test(
    location.pathname
  );

  // Function to determine the selected key based on the current path
  const getSelectedKey = () => {
    for (const item of adminMenu) {
      if (item.subMenu) {
        for (const subItem of item.subMenu) {
          if (subItem.path === currentPath) {
            return subItem.key;
          }
        }
      } else if (item.path === currentPath) {
        return item.key;
      }
    }
    return ""; // Set a default key if no match is found
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  let componentToRender;
  if (userRole && userRole.toLowerCase() === "admin") {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={adminMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else if (userRole && userRole.toLowerCase() === "superadmin") {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={superAdminMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else if (
    userRole &&
    (userRole.toLowerCase() === "agreement controller head" ||
      userRole.toLowerCase() === "agreement controller team")
  ) {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={legalMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={othersMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  }

  // Function to get initials from a name
  const getInitials = (name) => {
    if (!name) {
      // Redirect user to admin/login if name is not available
      window.location.href = "/auth/login"; // Update the URL as needed
      return null; // Return null or handle the redirection in the desired way
    }
    const parts = name && name.split(" ");
    return parts.map((part) => part[0]).join("");
  };

  // Calculate initials from the name
  const initials = getInitials(userName);

  // Style for the purple rounded background
  const rounderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#A395DA", // Purple color
    color: "#fff", // White text color
    padding: "0.5rem", // Adjust padding as needed
    width: "3rem", // Set a fixed width
    height: "3rem", // Set a fixed height
    maxWidth: "none", // Allow the box to expand fully
    maxHeight: "none", // Allow the box to expand fully
  };

  const onCloseNotification = () => {
    setOpen(false)
  }

  const onNotificationOpen = () => {
    setOpen(!open);
    if (!open) {
      dispatch(fetchAllNotifications({ user_id }));
    }

  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        bellRef.current &&
        !bellRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Layout className="flex bg-violet-100">
      <Header className="fixed-header px-2 bg-violet-100 h-[75px] flex justify-between flex-row border-b border-[1px] border-[#e0e0e0]"
      >
        <div className="flex justify-start flex-row">
          <div className="demo-logo-vertical">
            <div className="text-center mb-[20px] text-[40px] font-bold flex flex-col">
              <img src={logo} alt="CoreVentum Logo" className="h-20 pt-2 pb-4" />
            </div>
          </div>
          <button className="text-[25px] ml-8" onClick={() => { dispatch(onChangeCollapsed(!isCollapsed)) }}>
            {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </button >
        </div>
        <Space
          wrap
          size={16}
          style={{
            marginRight: "4em",
            marginLeft: "4em",
          }}
        >
          <button ref={bellRef} onClick={() => { onNotificationOpen() }} className="relative mt-4 ">
            <BellTwoTone className="text-3xl" />
            <span className="absolute top-0 right-0 -mr-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] text-white">
              {notifications.length}
            </span>
          </button>
          {/* <SearchOutlined /> */}
          <div className="flex items-center justify-between">
            <Dropdown
              menu={{
                items,
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <div style={rounderStyle}>{initials}</div>
                  <span className="text-balck text-lg ml-2">
                    {userName && userName}
                  </span>
                </Space>
              </a>
            </Dropdown>
          </div>
        </Space>
      </Header>
      <Layout className={`mt-[4rem] h-[94vh] transition-all duration-300 ${open ? " opacity-40 bg-black/40 pointer-events-none	overflow-hidden" : "bg-[#EBE8F7] opacity-100"}`}
      // bg-black/20 backdrop-blur-sm 
      >
        <Sider
          trigger={null}
          collapsible
          collapsed={isCollapsed}
          style={{
            marginTop: "24px",
            borderRadius: "0 10px 0 0",
            position: "fixed",
            left: 0,
            height: "89vh",
            zIndex: 1000,
            backgroundColor: "#122253",
          }}
        >
          {componentToRender}
        </Sider>

        <Content
          style={{
            marginTop: "24px",
            padding: isDashboardPage ? "0" : "24px",
            maxHeight: "calc(100vh - 105px)",
            overflowY: "auto",
            background: isDashboardPage
              ? "white"
              : isAnalyticsPage
                ? ""
                : colorBgContainer,
            marginLeft: isCollapsed ? "7em" : "15.5em",
            transition: "margin-left 0.2s",
            borderTopLeftRadius: "1rem",
            marginRight: "1.5rem",
            position: "relative",
          }}
        >
          <div className={`${userRole === "admin" && accessGranted === false ? "pointer-events-none select-none" : ""}`}>
            <Outlet />
          </div>

          {userRole !== "superadmin" && userRole !== "support" && accessGranted === false &&  userRole !== "demo" && (
            <div className="fixed  top-0 left-20 w-full h-full z-50 flex items-center justify-center bg-white/20 backdrop-blur-[.5px]">
              <div className="bg-white px-8 py-10 rounded-lg shadow-xl border border-gray-300 max-w-md w-full text-center card-access-dashboard">
                <div className="flex flex-col items-center justify-center space-y-4">
                  <div className="rounded-full bg-purple-100 p-4">
                    <div className="text-6xl text-[#4E36A3] font-bold z-10000">
                      <FileSearchOutlined />

                    </div>
                  </div>
                  <h2 className="text-2xl font-semibold text-gray-800">Access Restricted</h2>
                  <p className="text-sm text-gray-600 px-4">
                    {userRole === "admin"
                      ? `Access to your Coreventum CLM Software has been temporarily restricted. 
      You can access by logging in with the code "FREE15" to activate a Free License 
      for up to 3 users or 15 contracts.

      If you’ve already redeemed the Free License or are interested in our Enterprise Solution, 
      please reach out to us at producthead@coreventum.com or call ‪+91-9810600295‬.`
                      : "Please contact your admin for access."
                    }
                  </p>

                  {userRole === "admin" && <> <input
                    type="text"
                    placeholder="Enter access code"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                    className="w-full border border-gray-300 rounded px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                  />
                    <button onClick={handleSubmitAccessCode} className="w-full mt-2 bg-[#4E36A3] hover:bg-purple-800 text-white py-2 rounded transition duration-200">
                      Submit
                    </button></>}
                </div>
              </div>
            </div>
          )}

        </Content>


      </Layout>
      <Sider
        ref={notificationRef}

        trigger={null}
        collapsed={!open}
        className={`rounded mt-6 transition-all duration-300 overflow-hidden `}
        width={350}
        collapsedWidth={0}
        theme={'light'}
      >
        <div className=" mt-6 h-[89vh]  demo-logo-vertical py-4 overflow-y-scroll">
          <Notification onClose={onCloseNotification} />
          {/* {componentToRender} */}
        </div>
      </Sider>
    </Layout>
  );
};
export default React.memo(AntSidebar);
